module.exports = {"text_footer_disclaimer":{"componentName":"DisclaimerContent"},"text_footer_disclaimer_manor":{"componentName":"FooterManor"}}